import { Brand, Patient, Practice } from '@principle-theorem/principle-core';
import { type IPatient } from '@principle-theorem/principle-core/interfaces';
import {
  Firestore,
  toTimestamp,
  type Query,
  type WithRef,
} from '@principle-theorem/shared';
import { BigQueryJobName } from '../../job-names';
import { IPatientWriteTopicData } from '../../topic-data/topic-data';
import {
  BasicBigQuerySyncHandler,
  IBigQuerySyncRequest,
} from '../big-query-sync';

export class BigQueryPatientSyncHandler extends BasicBigQuerySyncHandler<
  IPatient,
  IPatientWriteTopicData
> {
  readonly bigQueryJobName = BigQueryJobName.PatientWrite;

  getQuery(request: IBigQuerySyncRequest): Query<IPatient> {
    const brandRef = Practice.brandRef({ ref: request.practiceRef });
    return Brand.patientCol({ ref: brandRef });
  }

  async getTopicData(
    patient: WithRef<IPatient>
  ): Promise<IPatientWriteTopicData> {
    const brand = await Firestore.getDoc(Patient.brandRef(patient));
    const organisation = await Firestore.getDoc(Brand.organisationRef(brand));
    return {
      organisation,
      brand,
      patient,
      timestamp: toTimestamp(),
    };
  }
}
